import React from 'react';
import {
  SplitBannersAdditionalProps,
  BannerInfoRecommendationModal,
} from './BannerInfoRecommendationModal';

type RecommededItemType = {
  id: number | string;
  type: string;
  name: string;
  image: string;
  manufacturer: string;
  isAddedToCart: boolean;
  isCartLoading: boolean;
  isInStock: boolean;
  linkUrl?: string;
};

export interface RecommendationModalProps {
  isOpen: boolean;
  addedMaterialImage: any;
  addedToCartLabel?: string;
  ecoTabsLevel?: number;
  recommendedItems: RecommededItemType[];
  shouldShowSustainabilityIcon?: boolean;
  backdropTopPadding?: number;
  onClose?: () => void;
  onAddToCart?: (addedItem: RecommededItemType) => void;
  onClickAway?: () => void;
  onMouseOver?: () => void;
  onRecommendedItemUrlClick?: (recommendedItem: RecommededItemType) => void;
}

export const RecommendationModal: React.FC<
  RecommendationModalProps & SplitBannersAdditionalProps
> = (props) => {
  return <BannerInfoRecommendationModal {...props} />;
};
